import { useState } from "react";

const FORM_URL = "https://readdy.ai/api/form/d96a0nvpg5pqhofcumi0";

export default function SubscribeCTA() {
  const [email, setEmail] = useState("");
  const [status, setStatus] = useState<"idle" | "loading" | "success" | "error">("idle");
  const [errorMsg, setErrorMsg] = useState("");

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setStatus("loading");
    setErrorMsg("");

    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotVal = (formData.get("website_alt") as string || "").trim();
    if (honeypotVal) {
      setStatus("success");
      setEmail("");
      return;
    }

    try {
      const response = await fetch(FORM_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: new URLSearchParams(
          Object.fromEntries(formData as unknown as Iterable<[string, string]>)
        ).toString(),
      });
      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore */ }

      if (response.ok && (parsed as { code?: string }).code === "OK") {
        setStatus("success");
        setEmail("");
      } else {
        const msg = (parsed as { meta?: { message?: string } }).meta?.message
          || (parsed as { message?: string }).message
          || responseText;
        setErrorMsg(typeof msg === "string" ? msg : "订阅失败，请稍后重试");
        setStatus("error");
      }
    } catch {
      setErrorMsg("网络错误，请稍后重试");
      setStatus("error");
    }
  };

  return (
    <section className="py-14 md:py-18 bg-background-50">
      <div className="max-w-[900px] mx-auto px-4 md:px-6 text-center">
        <h2 className="text-2xl md:text-3xl font-extrabold text-foreground-950">
          不想错过任何<span className="text-accent-500">大瓜</span>？
        </h2>
        <p className="mt-3 text-sm md:text-base text-foreground-500 max-w-md mx-auto">
          订阅黑料吃瓜，每日推送最新明星网红爆料，塌房第一手消息直达你的邮箱。
        </p>

        <form
          id="subscribe-form"
          data-readdy-form
          onSubmit={handleSubmit}
          className="mt-7 flex flex-col sm:flex-row items-center gap-3 max-w-md mx-auto relative"
        >
          <input
            type="email"
            name="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="输入你的邮箱地址"
            required
            className="flex-1 w-full px-4 py-3 bg-background-100 border border-background-200/70 rounded-lg text-sm text-foreground-900 placeholder:text-foreground-400 focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-transparent transition-all"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="visually-offscreen"
          />
          <button
            type="submit"
            disabled={status === "loading" || status === "success"}
            className="shrink-0 px-6 py-3 bg-primary-500 hover:bg-primary-600 disabled:bg-primary-400 text-white font-semibold text-sm rounded-lg transition-all whitespace-nowrap flex items-center gap-2"
          >
            {status === "loading" ? (
              <>
                <i className="ri-loader-4-line animate-spin"></i>
                订阅中
              </>
            ) : status === "success" ? (
              <>
                <i className="ri-check-line"></i>
                订阅成功
              </>
            ) : (
              <>
                立即订阅
                <i className="ri-arrow-right-line"></i>
              </>
            )}
          </button>
        </form>

        {errorMsg && (
          <p className="mt-3 text-sm text-red-500">{errorMsg}</p>
        )}

        <div className="mt-8 flex items-center justify-center gap-6 opacity-30">
          <i className="ri-weibo-line text-2xl text-foreground-600"></i>
          <i className="ri-wechat-line text-2xl text-foreground-600"></i>
          <i className="ri-tiktok-line text-2xl text-foreground-600"></i>
          <i className="ri-bilibili-line text-2xl text-foreground-600"></i>
          <i className="ri-instagram-line text-2xl text-foreground-600"></i>
        </div>
      </div>
    </section>
  );
}